@use "../../../../../styles/Colors.scss" as Colors;
@use "../../../../../styles/Constants.scss" as Constants;

$var-border: 1px solid Colors.$col-greyConnection;
$var-table-header-height: 64px;

.modal {
	width: Constants.$val-modal-xl !important;
	display: flex !important;
	justify-content: center !important;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.bigHeader {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: Constants.$val-fontSizeXBig;
	font-weight: bold;
	overflow: initial !important;

	&::before,
	&::after {
		display: none;
	}

	&__thin {
		font-size: Constants.$val-fontSizeXBig;
		font-weight: normal;
	}
}

.body {
	display: flex;
	align-items: center;
	justify-content: center;
}

.documentPreview {
	height: 500px;
	max-width: 600px;
}

.settings-actions {
	font-size: Constants.$val-fontSizeXXXBig;

	&__dropdown-toggle {
		color: Colors.$col-black;
		justify-content: center;
		cursor: pointer;

		&:focus,
		&:hover,
		&:active,
		&:active:hover,
		&:active:focus {
			color: Colors.$col-black;
		}
	}
}

input {
	&.input-text-field {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		background-color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		outline: none;
		height: Constants.$val-fieldSize;
		width: -webkit-fill-available;
	}
}

.date-field {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	text-align: center;
	align-items: baseline;

	&__date-time {
		margin-right: 2px;
	}

	&__updated-by {
		font-size: Constants.$val-fontSizeSmall;
		color: Colors.$col-greyFontLight;
	}
}

.drag-drop-style {
	background-color: Colors.$col-design-orange5;
	border-color: Colors.$col-orangeBorder;
	border-style: dashed;
}

.child-color {
	background-color: Colors.$col-orange-100;
}